import { Link } from "react-router-dom";
import { Meta } from "../components/Meta";
import { routes } from "../config/routes";
import { siteConfig } from "../config/site";

export function CartPage() {
  return (
    <main id="main">
      <Meta
        title="Bag | Beautify Ourselves"
        description="Orders are not currently available at Beautify Ourselves."
        path={routes.cart}
        noIndex
      />
      <header className="page-hero page-hero-compact">
        <div className="page-hero-inner">
          <p className="eyebrow">Your bag</p>
          <h1>Nothing can be ordered yet.</h1>
          <p className="lead">
            The bag, checkout and payment stay closed. When ordering opens, the confirmed
            delivery charge and full order total will be shown before payment.
          </p>
        </div>
      </header>
      <section className="section">
        <div className="section-inner cart-layout">
          <div className="empty-state">
            <h2>Orders are not currently available</h2>
            <p>{siteConfig.prelaunchNotice}</p>
            <Link className="button" to={routes.shop}>
              Browse the collection
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
